// Desktop popover container
export const popoverContainerClasses = [
  'tw:bg-white',
  'tw:rounded-8',
  'tw:shadow-lg',
  'tw:w-[22rem]',
  'tw:max-h-[24rem]',
  'tw:overflow-y-auto',
  'tw:py-small',
].join(' ');

// Title inside popover
export const popoverTitleClasses = [
  'tw:text-16 tw:font-bold',
  'tw:text-font',
  'tw:px-base tw:py-small',
].join(' ');

// Click-outside overlay (desktop)
export const overlayClasses = ['tw:fixed tw:inset-0', 'tw:z-40'].join(' ');

// Session row — outer container
export const sessionRowClasses = [
  'tw:flex tw:flex-col tw:gap-small',
  'tw:px-base tw:py-small',
  'tw:min-h-[2.75rem]',
  'tw:transition-colors tw:duration-150',
  'tw:rounded-8',
  'tw:mx-small',
  'tw:mb-small',
].join(' ');

// Urgency background variants
export const rowBgNormal = 'tw:bg-white tw:hover:bg-gray-lighter';
export const rowBgWarning = 'tw:bg-warn/10';
export const rowBgError = 'tw:bg-error/10';

// Row top section (dot + info)
export const rowInfoClasses = [
  'tw:flex tw:items-start tw:gap-small',
  'tw:no-underline',
  'tw:cursor-pointer',
].join(' ');

// Row left section (dot)
export const rowDotClasses = [
  'tw:w-2 tw:h-2',
  'tw:rounded-full',
  'tw:shrink-0',
  'tw:mt-[0.375rem]',
].join(' ');

export const rowDotActiveClasses = 'tw:bg-accent';
export const rowDotUpcomingClasses = 'tw:bg-primary';
export const rowDotExpiredClasses = 'tw:bg-warn';

// Row content area
export const rowContentClasses = ['tw:flex-1 tw:min-w-0', 'tw:flex tw:flex-col tw:gap-nano'].join(
  ' '
);

// Row top line (garage name + time)
export const rowTopLineClasses = ['tw:flex tw:items-center tw:justify-between tw:gap-small'].join(
  ' '
);

// Garage name in row
export const rowGarageNameClasses = [
  'tw:text-14 tw:font-semibold',
  'tw:text-font',
  'tw:truncate tw:min-w-0',
].join(' ');

// Time text in row
export const rowTimeTextClasses = ['tw:text-14 tw:font-medium', 'tw:shrink-0'].join(' ');

export const rowTimeActiveClasses = 'tw:text-font';
export const rowTimeExpiredClasses = 'tw:text-warn';

// Vehicle/subtitle text in row
export const rowVehicleTextClasses = [
  'tw:text-12 tw:font-regular',
  'tw:text-gray-dark',
  'tw:truncate',
].join(' ');

// Action buttons row
export const rowActionsClasses = ['tw:flex tw:items-center tw:gap-small', 'tw:pl-[1.25rem]'].join(
  ' '
);
